<template>
  <q-card flat :style="isSelectForm?'width:500px;min-width:500px':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <div>
          مدیریت زنجیره وابستگی فروش
          {{ goodsInfo.Goods_Name }}
          <q-badge align="top" color="red" text-color="white" :label="goodsInfo.Goods_Code"/>
        </div>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <div class="row">
        <div class="col-md-4 col-xs-12" v-if="!$q.screen.lt.md && !isSelectForm">
          <GroupList :is-compact-view="true" :is-dialog="false" @group-selected="groupSelected"/>
        </div>
        <div class="col-xs-12 col-md-4" v-if="!isSelectForm">
          <ProductInfoSearchPanel/>
          <ProductInfoSearchResultLocalComponent
              :by-pass-insert-dialog="true"
              :is-selection-form="true"
              :show-groups="false"
              @select-goods="goodsAdding"/>
        </div>
        <div :class="isSelectForm?'col-xs-12':'col-md-2 q-ml-sm col-xs-12'">
          <ProductDependency :is-select-form="isSelectForm" :items="items" :goods-info="goodsInfo"
                             @remove-item='removeItem'/>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import ProductInfoSearchPanel from "@/components/productInfo/ProductInfoSearchPanel";
import {mapActions} from "vuex";
import GroupList from "@/components/productInfo/GroupList";
import EventBus from "@/event-bus";
import ProductDependency from "@/components/productInfo/ProductDependency";

export default {
  name: "ProductDependencyManage",
  components: {
    'ProductInfoSearchResultLocalComponent': () => import('./ProductInfoSearchResult'),
    'ProductDependency': ProductDependency,
    GroupList,
    ProductInfoSearchPanel
  },
  props: {
    goodsInfo: {
      type: Object,
    },
    isSelectForm: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      items: []
    }
  },
  methods: {
    ...mapActions({
      getProductListBuGroupID: 'Products/getByGroupID',
      loadDependency: 'Products/loadDependencyGoods'
    }),
    removeItem(args) {
      this.items = this.items.filter(item => item.Goods_ID !== args.Goods_ID)
    },
    goodsAdding(args) {
      this.items.push(args)
      this.$q.notify({
        type: 'positive',
        color: 'positive',
        position: 'top',
        message: 'محصول افزوده شد'
      })
    },
    groupSelected(args) {
      this.getProductListBuGroupID(args.Group_ID).then((res) => {
        EventBus.$emit('invoke-productinfo-search-result-event', res);
      })
    }
  },
  created() {
    this.loadDependency(this.goodsInfo.Goods_ID).then((res) => {
      this.items = res
    })
  }
}
</script>

<style scoped>

</style>